// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

	

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});



	//remove tag P for button
	$('.about-us .first-part p a').each(function() {
		$(this).parent(1).contents().unwrap();
	});


	//Prevents fancybox links from opening
	$("a.fancybox").on("click", function(e){
		e.preventDefault();
	});

	
		

		$('.scrolldown').click(function (e) {
			e.preventDefault();
			const topHeight = $('.intro-content').height();
			$('html,body').animate({
				scrollTop: topHeight
			}, 500);
		});

		if(location.pathname.indexOf('portfolio')>-1 && location.hash.length>1){
			setTimeout(()=>{

				// Active item if select point map
				let url = window.location;
				let urlStr = url.hash;
				const strSlice = urlStr;
				const newStr = strSlice.slice(1);
				let idStringItems = document.querySelectorAll('.item.bottom');

				for (let i = 0; i < idStringItems.length; i++) {
					let idStringItem = idStringItems[i].id;
					if (idStringItem === newStr) {
						document.getElementById(idStringItem).className = 'item bottom active';
					}
				}	

			   	window.location.replace(location.href);
				
		   },700)
	   }
	   if (window.location.pathname === "/portfolio") {
			setInterval(() => {
				const buttonActive = document.querySelector("#map--wrapper a.btn")
					if (buttonActive) {
						const hashItem = buttonActive.href.split("#")[1]
						const cardActive = document.querySelector(`#${hashItem}`);
						if (buttonActive.href.split("#").length > 0) {
							buttonActive.setAttribute("href", "#" + buttonActive.href.split("#")[1])
						}
						buttonActive.addEventListener("click", () => {
							if ( hashItem &&  cardActive ) {	
								setTimeout(() => {
									window.scroll({top: cardActive.offsetTop - 250, behavior: 'smooth'})								
								}, 300);							
							}
							const allCards = document.querySelectorAll(".item.bottom")
							allCards.forEach(element => {
								element.classList.remove("active")
							});
							if (cardActive) {
								cardActive.classList.add("active")
							}
						})
					}
			}, 500);
	   }
			
		
			$('.sym-slides').slick({
				accessibility: false
			});

		$('p').each(function() {
			var $this = $(this);
			if($this.html().replace(/\s| /g, '').length == 0){
			  $this.remove();
			}
		  });
		  
	
		
		function readytosearch(){
			document.getElementsByClassName('search--block')[0].classList.add('active');
		}
		function outtosearch(){
			document.getElementsByClassName('search--block')[0].classList.remove('active');
		}


		  
			$( ".reset" ).click(function() {
				$('#attraction-category').prop('disabled', false);	
				$('#attraction-brand').prop('disabled', true);

			});



			//Load more team

			$(".team .item")
			.slice(0, 20)
			.show();
			$(".team .item:hidden").css("opacity", 0);
			if ($(".team .item:hidden").length == 0) {
				$("#loadMore").css('display','none');
			} 
			$("#loadMore").on("click", function(e) {
					$(".team .item:hidden")
						.slice(0, 20)
						.slideDown("slow")
						.animate(
						{
							opacity: 1
						},
						{
							queue: false,
							duration: "slow"
						}
						);
					if ($(".team .item:hidden").length == 0) {
						$("#loadMore").fadeOut("slow");
						$("#loadMore").css("opacity", 0);
					}
				e.preventDefault();
			});

			//Load more blog

			$(".blog .item")
			.slice(0, 4)
			.show();
			$(".blog .item:hidden").css("opacity", 0);
			if ($(".blog .item:hidden").length == 0) {
				$("#loadMore1").css('display','none');
			} 
			$("#loadMore1").on("click", function(e) {
					$(".blog .item:hidden")
						.slice(0, 12)
						.slideDown("slow")
						.animate(
						{
							opacity: 1
						},
						{
							queue: false,
							duration: "slow"
						}
						);
					if ($(".blog .item:hidden").length == 0) {
						$("#loadMore1").fadeOut("slow");
					}
				e.preventDefault();
			});

		$('#main_timeline_slider-10028').slick();
		$("#timeline-10028 li:first-child").addClass('active');
		$("#timeline-10028 li").click(function(event){
		event.preventDefault();
		let slideIndex = $(this).index();
		$( '#main_timeline_slider-10028' ).slick('slickGoTo',slideIndex );
		//$(this).addClass('active');
	  });
	  $('#main_timeline_slider-10028').on('afterChange', function(event, slick, currentSlide, nextSlide){
		  var currentId = $('#main_timeline_slider-10028 .slick-current').attr('id');
		  $("#timeline-10028 li").removeClass('active');
		  $('#trigger_'+currentId+'').addClass('active');
		});
	

		$('#main_timeline_slider-10802').slick();
		$("#timeline-10802 li:first-child").addClass('active');
		$("#timeline-10802 li").click(function(event){
		event.preventDefault();
		let slideIndex = $(this).index();
		$( '#main_timeline_slider-10802' ).slick('slickGoTo',slideIndex );
		//$(this).addClass('active');
	  });
	  $('#main_timeline_slider-10802').on('afterChange', function(event, slick, currentSlide, nextSlide){
		  var currentId = $('#main_timeline_slider-10802 .slick-current').attr('id');
		  $("#timeline-10802 li").removeClass('active');
		  $('#trigger_'+currentId+'').addClass('active');
		});


	
	


		// 	/*****************************************************
		//  OBSERVER TO ADD PARALLAX EFFECT
		//  /*****************************************************/
		//  var scrollParallax = []
		//  var scrolled = 0
 
		//  // screen height
		//  var v_height = window.innerHeight
		// 	 || document.documentElement.clientHeight
		// 	 || document.body.clientHeight;
 
		//  function doParallax(elm) {
 
		// 	 let boundes = elm.dataset.parallax.split(",") // get it from html
		// 	 //get distance in positive value
		// 	 let distance = Math.abs(boundes[0] - boundes[1])
		// 	 if (boundes[0] > boundes[1]) {
		// 		 //get distance in negative value (to do the scroll inverse)
		// 		 distance = distance * -1
		// 	 }
		// 	 //Equivalent distance using screen height + element height
		// 	 const unit_scroll = distance / (v_height + elm.offsetHeight)
		// 	 let temp = 0
 
		// 	 let topElement = 0;
		// 	 let element = elm;
 
		// 	 let id_elem = elm.dataset.parallaxid
 
		// 	 do {
		// 		 topElement += element.offsetTop || 0;
		// 		 element = element.offsetParent;
		// 	 } while (element)
 
		// 	 let parallaxFunction = function () {
		// 		 //Obtain the distance between top screen and document top 0
		// 		 scrolled = document.documentElement.scrollTop || window.pageYOffset
		// 		 //Distance of bottom page to top of the element
		// 		 let relative_distance = scrolled + v_height - topElement
		// 		 //transpoling data to move the parallax element relative to the scroll of all the screen
		// 		 temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
		// 		 //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
		// 		 elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
		// 	 }
 
		// 	 scrollParallax[id_elem] = parallaxFunction
 
		// 	 window.addEventListener('scroll', scrollParallax[id_elem])
 
		//  }
 
		//  let observers_parallax = document.querySelectorAll(".js-parallax-element")
 
		//  if (observers_parallax) {
		// 	 let options_parallax = {
		// 		 root: null, // relative to document viewport
		// 		 rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
		// 		 threshold: 0 // visible amount of item shown in relation to root
		// 	 }
 
		// 	 function handler_parallax(entries, observer) {
		// 		 let entry;
		// 		 entries.forEach(function (entry) {
		// 			 if (entry.isIntersecting) {
		// 				 doParallax(entry.target)
		// 			 } else {
		// 				 let id_elem = entry.target.dataset.parallaxid
		// 				 window.removeEventListener('scroll', scrollParallax[id_elem])
		// 			 }
		// 		 })
		// 	 }
 
		// 	 let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
		// 	 let counter = 1
		// 	 observers_parallax.forEach(function (element) {
		// 		 observable_parallax.observe(element)
		// 		 element.dataset.parallaxid = counter
		// 		 counter++
		// 	 })
		//  }
		//  /********************************************************************************
		//   END OF OBSERVER TO ADD PARALLAX EFFECT
		//   ***********************************************************************************/

		
		 
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		

		// var controller = new ScrollMagic.Controller();
		
		// //parallax-image-intro
		// $(".wrapper-parallax, .animated-img").each(function() {
		//   var tl = new TimelineMax();
		//   var child = $(this).find(".child, img");
		//   tl.to(child, 1, { y: -180, ease: Linear.easeNone });
		
		//   var scene = new ScrollMagic.Scene({
		// 	triggerElement: this,
		// 	triggerHook: 0.4,
		// 	duration: "100%"
		//   })
		// 	.setTween(tl)
		// 	.addIndicators({
		// 	  colorTrigger: "transparent",
		// 	  colorStart: "transparent",
		// 	  colorEnd: "transparent",
		// 	  indent: 10
		// 	})
		// 	.addTo(controller);
		// });

		// Map: Returnxw to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/


		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});

		
	};

}());


// $(window).bind('load resize', function(){
// 	var winWidth = $(window).innerWidth();
// 	if(winWidth<1024){
// 		$('#history .timeline').css('height','auto');
// 		$('#history .timeline').slick({
// 			arrows: false,
// 			dots: true,
// 			adaptiveHeight:true
// 		});
// 	}
// })


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
}
